"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IconButton_1 = require("./IconButton");
exports.default = IconButton_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/IconButton/index.js
// module id = 1774
// module chunks = 8